import { getPageUrl } from "#scripts/general_functions.js";
import language from "#scripts/translation";
import { login, logout, isLogedin } from "#scripts/idporten.js";
// import { ReplayEventWithTime } from "@sentry/browser";

export const userLogin = () => {
	if (!window.serverdata.configMeta.aim?.mysite?.enabled) {
		return;
	}
	const pageColor = window.serverdata.configMeta.aim.style?.minside?.page__color || "var(--primary__color-200)";
	const template = getPageUrl().template;
	const mypageLink = window.serverdata.configMeta.aim.mysite?.link || "/minkommune";

	localStorage.setItem("loginRedirect", window.location.href);

	// if (template === "minside") {



	document.body.addEventListener("keyup", (event) => {
		if (event.key === "Enter") {
			if (event.target.classList.contains("userlogin__selector")) {
				event.preventDefault();
				location.replace(mypageLink);
			}
		}
	});

	document.body.addEventListener("click", (event) => {
		if (event.target.classList.contains("userlogin__selector__expand")) {
			event.preventDefault();

			// Toggle 'active' class on the clicked element
			event.target.closest(".userlogin__selector__expand").classList.toggle("active");

			// Toggle classes on all elements with the class 'userlogin__selector__expand'
			for (const element of document.querySelectorAll(".userlogin__selector__expand")) {
				element.classList.toggle("userlogin__selector__expand_more");
				element.classList.toggle("userlogin__selector__expand_less");
			}

			// Toggle 'userlogin__menu__show' class on elements with the class 'userlogin__menu'
			for (const element of document.querySelectorAll(".userlogin__menu")) {
				element.classList.toggle("userlogin__menu__show");
			}
		}
	});

	document.body.addEventListener("click", (event) => {
		if (event.target.closest(".userlogin__menu__item")) { //event.target.classList.contains('userlogin__selector__expand')
			event.preventDefault();
			const selMenuItem = event.target.closest(".userlogin__menu__item").children[0].innerText.trim();
			switch (selMenuItem) {
				case "Logg inn":
					login();
					break;
				case "Logg ut":
					logout();
					break;
				// case "Renew Token":
				//     renewToken();
				//     break;
			}

			// location.reload();
		}
	});

		document.body.addEventListener("click", (event) => {
		if (event.target.classList.contains("userlogin__selector__text") || event.target.classList.contains("userlogin__selector__icon") || event.target.classList.contains("userlogin__selector-inner")) {
			event.preventDefault();
			location.replace(mypageLink);
		}
	});

	return userLoginTemplate({
		userInfo: "Test",
		icon: window.serverdata.configMeta.aim.mysite.icon || "lock_person",
	});
};

export const userLoginTemplate = (obj) => {
	isLogedin().then((data) => {
		if (data) {
			// Change menu to reflect that the user is logged in
			const ssn = localStorage.getItem("access_pid");
			// const loginButtonText = ssn.replace(/.{1,6}(?=(.{5})+$)/g, "$& ");
			const menu = `<span class="material-icons-outlined userlogin__selector__expand header__icon userlogin__selector__expand_more"></span>
										<div id="userlogin_menu" class="userlogin__menu">
											<div class="d-none userlogin__menu__item">Ole Hartvig</div>
											<div class="userlogin__menu__text_item">${`${ssn.substring(0, 6)} *****`}</div>
											<hr/>
											<!--a href="#" class="userlogin__menu__item"><div>Renew Token</div><span class="material-icons-outlined userlogin__menu__logout__icon">login</span></a-->
											<a href="#" class="userlogin__menu__item"><div>Logg ut</div><span class="material-icons-outlined userlogin__menu__logout__icon">logout</span></a>
										</div>`;
			document.querySelector(".userlogin__selector-inner")?.classList.add("loggedin");
			document.getElementById("userlogin_text")?.insertAdjacentHTML("afterend", menu);
		} else {
			document.querySelector(".userlogin__selector-inner")?.classList.remove("loggedin");
			document.getElementById("userlogin_text").innerText = language("NAV_MYPAGE");
		}
	});
	return `
        <div class="userlogin__selector" tabindex="0">
          <div class="userlogin__selector-inner">
            <span class="material-icons-outlined userlogin__selector__icon header__icon">${obj.icon}</span>
            <span id="userlogin_text" class="userlogin__selector__text">${language("NAV_MYPAGE")}</span>
          </div>
        </div>
    `;
};

export { userLogin as default };
